import React, { useState, useEffect, useRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  OutlinedInput,
  DialogActions,
  DialogContent,
  DialogTitle,
  
} from '@mui/material';
import axios from '../../../../utils/fvAxios';
import apiinfo from '../../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';
import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken } from "../../../../utils/Token";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { TextField, Stack } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ClientUploads({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const { register } = useForm();
  const [token, setToken] = useState(getToken())
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
        getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          // if(getOrgType()=="Client"){
          //   setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });
  }, []);

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const date = new Date();
  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}
var d = new Date(); // today!
var x = 30; // go back 30 days!

  const [fromDateValue, setFromDateValue] = useState(formatDate(d.setDate(d.getDate() - x)));
  const [toDateValue, setToDateValue] = useState(formatDate(date));


// print date to console

  const [toDateError, setToDateError] = useState('');


  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };

  const handleFromDateChange = (event) => {
    setFromDateValue(event);
  };

  const handleToDateChange = (event) => {
    setToDateValue(event);

  };

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleDocTypeChange = (event) => {
    setSelectedDocs(event.target.value);
  };
  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl + 'ClientUploadsFromQuestionnaire.aspx'
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: '20px' }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                {' '}
                From{' '}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: '340px' }}
                name="fromDate"
                size="small"
                value={fromDateValue || ''}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month", "day"]}
                      value={fromDateValue || ''}
                      onChange={handleFromDateChange}
                       name="fromDate"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "340px",
                          }}
                          size="small"
                           name="fromDate"
                          onKeyDown={handleDateKeyDown}
                        />
                      )}
                    />
                  </LocalizationProvider>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                To
              </span>
              {/* <TextField
                type="date"
                sx={{ width: '340px' }}
                name="toDate"
                size="small"
                value={toDateValue || ''}
                onChange={handleToDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month", "day"]}
                      value={toDateValue || ''}
                        name="toDate"
                      onChange={handleToDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "340px",
                          }}
                            name="toDate"
                          size="small"
                          onKeyDown={handleDateKeyDown}
                        />
                      )}
                    />
                  </LocalizationProvider>
              <span className='text-danger'>{toDateError}</span>

            </FormControl>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                Client
              </span>

              <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small'
                sx={{ width: "340px", overflow: "hidden" }}
                name="clientIds"
                value={selectedDocs}
                onChange={handleDocTypeChange}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }
                }
                renderValue={(selected) =>
                  selected
                    .map((value) => client?.find((doc) => doc?.value === value)?.text)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">

                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedDocs?.length > 0 && selectedDocs?.length < client?.length
                    }
                    checked={selectedDocs?.length === client?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedDocs(client?.map((doc) => doc?.value));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedDocs([]);
                      }
                    }}
                  />
                  <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>
                </MenuItem>
                {client?.map((doc) => (
                  <MenuItem key={doc?.value} value={doc?.value}>
                    <Checkbox checked={selectedDocs?.indexOf(doc?.value) > -1} />
                    <ListItemText primary={doc.text} sx={{ overflowX: "hidden" }} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="login-button-request"
                type="submit"
                onClick={close}
                disabled={selectedDocs == ""}
              >
                Create Report
              </Button>
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>
        <br />
      </DialogContent>
    </>
  );
}
